import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Reveal from '../components/Reveal';
import PageHeader from '../components/PageHeader';
import { useLanguage } from '../context/LanguageContext';
import './Services.css';

// Une photo par service ; les fichiers sont dans public/img
const SERVICE_IMAGES = {
  svc1: 'gallery3',
  svc2: 'gallery5',
  svc3: 'buffet-sculpte',
  svc4: 'atelier/conception-plan-cuisine',
  svc5: 'atelier/poncage-finition-vernis',
  svc6: 'atelier/pose-cuisine-saly',
  svc7: 'atelier/porte-signature-villa',
  svc8: 'gallery16',
  svc9: 'lamine/lamine-01-cuisine'
};

const Services = () => {
  const { t } = useLanguage();

  const services = Object.keys(SERVICE_IMAGES).map((key) => ({
    key,
    image: `/img/${SERVICE_IMAGES[key]}.webp`,
    title: t(`${key}_title`),
    description: t(`${key}_desc`),
    features: [1, 2, 3, 4].map((n) => t(`${key}_f${n}`))
  }));

  const steps = [1, 2, 3, 4].map((n) => ({ n, title: t(`proc${n}_title`), text: t(`proc${n}_desc`) }));
  const reasons = [1, 2, 3, 4].map((n) => ({ title: t(`reason${n}_title`), text: t(`reason${n}_desc`) }));

  return (
    <div className="services-page">
      <PageHeader
        image="/img/gallery8.webp"
        eyebrow={t('services_eyebrow')}
        title={t('services_title')}
        subtitle={t('services_page_subtitle')}
      />

      <section className="section">
        <div className="container">
          <div className="services-list">
            {services.map((service, index) => (
              <Reveal as="article" key={service.key} delay={(index % 2) * 100} className="service-card">
                <div className="img-frame service-card-img">
                  <img src={service.image} alt="" loading="lazy" />
                </div>
                <div className="service-card-body">
                  <span className="service-card-num">{String(index + 1).padStart(2, '0')}</span>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <ul className="service-features">
                    {service.features.map((feature) => (
                      <li key={feature}>
                        <FontAwesomeIcon icon={faCheck} />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <div className="service-card-foot">
                    <span className="service-price">{t('price_on_request')}</span>
                    <Link to={`/contact?service=${encodeURIComponent(service.title)}`} className="text-link">
                      {t('nav_quote_btn')} <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <Reveal as="div" className="section-head">
            <span className="eyebrow">{t('services_process_eyebrow')}</span>
            <h2>{t('services_process_title')}</h2>
          </Reveal>
          <ol className="process-steps">
            {steps.map((step, index) => (
              <Reveal as="li" key={step.n} delay={index * 110} className="process-step">
                <span className="process-num">0{step.n}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal as="div" className="section-head">
            <span className="eyebrow">{t('services_why_eyebrow')}</span>
            <h2>{t('services_why_title')}</h2>
          </Reveal>
          <div className="reasons-grid">
            {reasons.map((reason, index) => (
              <Reveal as="div" key={reason.title} delay={index * 90} className="reason-card">
                <h3>{reason.title}</h3>
                <p>{reason.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-alt cta-band">
        <Reveal as="div" className="container">
          <h2>{t('services_cta_title')}</h2>
          <p>{t('services_cta_subtitle')}</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">{t('nav_quote_btn')}</Link>
            <Link to="/gallery" className="btn btn-secondary">{t('services_cta_gallery_btn')}</Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
};

export default Services;
